import React, { useState } from "react";
import InvItem from "./invItem";
// import Filter from "./components/filter";

const InventoryTable = (props) => {
  const { items, handleDecrement, handleIncrement, handleDelete } = props;

  const [filter, setFilter] = useState({
    filterState: 0,
    filterOp: 1,
    filterCount: 0,
    filterName: "",
  });

  // console.log("Entered InventoryTable with props ", props);

  const handleFilterChange = (x) => {
    console.log("handleFilterChange:: x", x);
  };

  const FilterItem = (props) => {
    return (
      <span key="editItem1">
        <input
          id="filterItem"
          value={props.itemSearch}
          onChange={props.onChange}
        ></input>
      </span>
    );
  };

  const handleFilterItem = (event) => {
    event.preventDefault();
    console.log("handleFilterItem event = ", event);
    console.log("handleFilterItem filter = ", filter);
    const count = filter.filterCount;
    let { filterState, filterOp, filterCount, filterName } = filter;
    setFilter({
      filterState,
      filterOp,
      filterCount,
      filterName: event.target.value,
    });
  };

  const handleFilterCount = (event) => {
    event.preventDefault();
    console.log("handleFilterCount: event = ", event);
    console.log("value = ", event.target.value);
    const val = parseInt(event.target.value);
    console.log("filter = ", filter.filterCount);
    if (Number.isInteger(val)) {
      setFilter({
        filterState: 0,
        filterOp: 0,
        filterCount: val,
        filterName: "",
      });
    }
  };

  const FilterCount = (props) => {
    // console.log("FilterCount props", props);
    return (
      <span>
        <button className="filterOp" id="less">
          &lt;
        </button>
        <button className="filterOp" id="equal">
          =
        </button>
        <button className="filterOp" id="greater">
          &ge;
        </button>
        <input
          id="filterCount"
          value={props.count}
          onChange={props.onChange}
        ></input>
      </span>
    );
  };

  const Filter = ({ onChange, ...filterData }) => {
    // console.log("Filter func {filterState} = ", filterState);
    console.log("Filter func {onChange} = ", onChange);
    console.log("Filter func {filterData} = ", filterData);
    return (
      <div>
        <div class="row">
          <button>Filter X</button>
        </div>
        <table>
          <thead>
            <tr>
              <th>Count</th>
              <th>Item</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                {/* <label for="less">&lt;</label> */}
                <br></br>
                <input
                  type="radio"
                  name="filter-op"
                  id="less"
                  value="X"
                ></input>
                <input type="radio" name="filter-op" id="equal"></input>
                <input type="radio" name="filter-op" id="greater"></input>
              </td>
            </tr>
            <tr>
              <td>
                <input id="filter-count" value={filterData.filterCount}></input>
              </td>
              <td>
                <input id="filter-item" value={filterData.filterName}></input>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  };
  return (
    <div className="inventory-table container">
      <form id="inventory-table">
        <table style={{ width: 100 + "%" }}>
          <thead>
            <tr>
              <th>
                <span>Item</span>
                <span className="filter-name">
                  <input
                    name="itemFilterName"
                    value={props.filterItemName}
                    onChange={props.handleFilterUpdate}
                  ></input>
                </span>
              </th>
              <th>
                <span>Count</span>
                <span className="filter-count">
                  <input
                    name="itemFilterCount"
                    value={props.filterItemCount}
                    onChange={props.handleFilterUpdate}
                  ></input>

                  <button
                    type="button"
                    className={props.filterItemOp < 0 ? "highlight-button" : ""}
                    name="itemFilterOpL"
                    onClick={props.handleFilterUpdate}
                  >
                    &lt;
                  </button>
                  <button
                    type="button"
                    className={
                      props.filterItemOp == 0 ? "highlight-button" : ""
                    }
                    name="itemFilterOpE"
                    onClick={props.handleFilterUpdate}
                  >
                    =
                  </button>
                  <button
                    className={
                      props.filterItemOp == 1 ? "highlight-button" : ""
                    }
                    type="button"
                    name="itemFilterOpGE"
                    onClick={props.handleFilterUpdate}
                  >
                    &ge;
                  </button>
                </span>
                {/* <FilterCount
                  onChange={handleFilterCount}
                  count={filter.filterCount}
                ></FilterCount> */}
              </th>
              <th>Size</th>
              <th>UPC</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {items.map((x) => {
              return (
                <InvItem
                  key={x.id}
                  filter={filter}
                  count={x.count}
                  item={x}
                  handleDecrement={handleDecrement}
                  handleIncrement={handleIncrement}
                  handleDelete={handleDelete}
                />
              );
            })}
          </tbody>
        </table>
      </form>
    </div>
  );
};

export default InventoryTable;
